import { Component, ChangeDetectionStrategy } from '@angular/core';


@Component({
	selector: 'experience-overview-tab-1-part',
	standalone: true,
	templateUrl: './experience-overview-tab-1.part.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	styleUrls: [`./experience-overview-tab-1.part.scss`],
})
export class ExperienceOverviewTab1Part {
}
